import { DatabaseOutlined } from '@ant-design/icons-vue'

export default [
  {
    path: '/device',
    name: 'device',
    redirect: '/device/list',
    meta: { title: '设备管理', sort: 2, icon: DatabaseOutlined, isFullScreen: false, prem: true },
    children: [
      {
        path: '/device/list',
        name: 'deviceList',
        component: () => import('@/views/device/list/index.vue'),
        meta: { title: '设备列表', sort: 1, isFullScreen: false, keepAlive: true, prem: true },
      },
      {
        path: '/device/detail',
        name: 'deviceDetail',
        component: () => import('@/views/device/detail/index.vue'),
        meta: {
          title: '设备详情',
          isFullScreen: false,
          keepAlive: false,
          hidden: true,
          prem: true,
        },
      },
      {
        path: '/device/player',
        name: 'devicePlayer',
        component: () => import('@/views/device/player/index.vue'),
        meta: {
          title: '设备回放',
          isFullScreen: false,
          keepAlive: false,
          hidden: true,
          prem: true,
        },
      },
      {
        path: '/device/demo',
        name: 'deviceDemo',
        component: () => import('@/views/device/demo/room.vue'),
        meta: {
          title: '设备演示',
          sort: 2,
          isFullScreen: true,
          keepAlive: false,
          prem: true,
        },
      },
      // {
      //   path: '/device/demo/room-editor',
      //   name: 'deviceDemoRoomEditor',
      //   component: () => import('@/views/device/demo/room-editor.vue'),
      //   meta: {
      //     title: '户型编辑器演示',
      //     sort: 2,
      //     isFullScreen: true,
      //     keepAlive: false,
      //     prem: true,
      //   },
      // },
      // {
      //   path: '/device/demo/room',
      //   name: 'deviceDemoRoom',
      //   component: () => import('@/views/device/demo/room.vue'),
      //   meta: {
      //     title: '全屋设备展示',
      //     sort: 3,
      //     isFullScreen: true,
      //     keepAlive: false,
      //     prem: true,
      //   },
      // },
    ],
  },
]
